import { featureFlags } from '@seen/core/featureFlags'
import { ExtendedDocumentReference } from '@seen/core/models/document-references/documentReferences'
import type { QueryTypes } from '@seen/core/search'
import { useFeatureFlag } from '#src/hooks/useFeatureFlag.ts'

// Browse and search surfaces other than the Documents table list one row per
// lab result too. Flag off, the query is returned as is.
export function useLabCopySecondaryFilter(): (query: QueryTypes) => QueryTypes {
  const labCopyGrouping = useFeatureFlag(featureFlags.labCopyGrouping)
  return (query) =>
    labCopyGrouping
      ? ExtendedDocumentReference.excludingLabCopySecondaries(query)
      : query
}
